import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 9h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5","key":"svg-0"}],["path",{"d":"M13 15v-6l3 4l3 -4v6","key":"svg-1"}]]

/**
 * IconServicemark
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItc2VydmljZW1hcmsiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTkgOWgtMi41YTEuNSAxLjUgMCAwIDAgMCAzaDFhMS41IDEuNSAwIDAgMSAwIDNoLTIuNSIgLz4KICA8cGF0aCBkPSJNMTMgMTV2LTZsMyA0bDMgLTR2NiIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/servicemark
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconServicemark = createReactComponent('outline', 'servicemark', 'Servicemark', __iconNode);

export default IconServicemark;